import {Factory} from './Factory'
import Menu from '../EditorComponents/TextEditor/Menu'

export class TextEditorFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('text-editor'),
      slug: 'editor-text',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      name: 'TextEditor',
    }
  }

  properties() {
    return {
      styles: [
        {key: 'margin', component: 'MarginProperty',},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
			menu: Menu
    }
  }
}